export const calculateAspectRatio = (aspectRatio: string): number => {
	if (typeof aspectRatio !== 'string' || !aspectRatio) {
		console.warn('Video aspect ratio is not a string or is empty. Fallback to 16:9.')
		return 16 / 9
	}

	const [width, height] = aspectRatio.split('/').map(Number)
	return width / height
}
